export default "__VITE_ASSET__BG08KvNw__"